module.exports = __webpack_public_path__ + "img/bac64cd.png";